<template>
  <div class="quota-list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        :option="option"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @row-click="handleDetail"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!-- <el-button type="primary"  @click="openFilter">
                        <a-icon type="filter" /> 高级筛选
                    </el-button> -->
        </template>

        <template slot="name" slot-scope="{ row }">
          <div class="project-name project_name" @click="handleDetail(row)">
            {{ row.name }}
          </div>
        </template>
      </avue-crud>
    </div>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import commonList from "@/mixins/list";
import { implementationListConfig } from "./config.js";
import { getQuotaList, deleteQuota } from "@/api/factoring/factoringScheme";

import { mapGetters } from "vuex";
export default {
  name: "implementationList",
  mixins: [commonList],
  data() {
    return {
      drawer: false,
      tableData: [],
      form: {},
      searchForm: {},
      checkUserList: [],
      checkdepartment: [],
      option: implementationListConfig(
        this.getMoney,
        this.selectPersonClick,
        this.selectDeptClick
      ),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      selectionList: [],
      disabled: true,
      webUrl: "",
    };
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {},
  methods: {
    cloudTages(data) {
      this.searchForm = data;
    },

    async queryTableData() {
      let that = this;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
      };
      let res = await getQuotaList(params);
      if (res.data.code == 200) {
        let list = res.data.data.records;

        this.tableData = list;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    //搜索
    searchChange(params, done) {
      this.searchForm = params;
      this.page.currentPage = 1;
      this.queryTableData();
      done();
    },
    //清空
    searchReset() {
      if (this.cloudStatus) {
        this.cloudStatus = false;
        return;
      }
      this.searchForm = {};
      this.checkUserList = [];
      this.queryTableData();
    },

    save(row) {
      this.$refs.cloudtage.save(row);
    },
    handleDetail(item) {
      let redirectUrl = encodeURIComponent(
        `${window.location.origin}/${item.url}&ssoToken=${this.userInfo.fanruan_ssoToken}`
      );
      this.$router.push({
        path: `/myiframe/urlPath?name=${item.name}&src=${redirectUrl}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.quota-list-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  .project_name {
    color: #409eff;
  }
  .quota-status {
    position: relative;
    padding-left: 20px;
  }
  .quota-status::before {
    position: absolute;
    content: "";
    background-color: #19b16b;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    left: 12px;
    top: 7px;
  }
  .red-point::before {
    color: #f56c6c !important;
  }
}
</style>